import React from 'react';
import EqpAgentMngContainer from '../../containers/eqpmng/EqpAgentMngContainer';

const EqpAgentMngPage = () => {
  return <EqpAgentMngContainer />;
};

export default EqpAgentMngPage;
